import { Skeleton } from '@mui/material';
import { useGoalById } from 'features/goals';
import { useIsFavorite, useToggleFavorite } from 'features/user';
import React, { useRef } from 'react';
import { useParams } from 'react-router';
import { MenuDotsCircle18, Star18 } from 'shared/assets/icons';
import { GoalContextMenu } from 'shared/components/connected/goal-context-menu';
import { Colors, IconButton, Sizes } from 'shared/components/ui/icon-button';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { FavoriteType } from 'shared/types/user-settings';

import * as Styled from './page-top-bar.style';

export const LoadingInteractions: React.FC = () => (
  <Skeleton animation="wave" width="6.4rem" height="3.2rem" />
);

export const Interactions: React.FC = () => {
  const interactionsRef = useRef<HTMLDivElement>(null);

  const { id } = useParams();
  const goal = useGoalById(id);
  const isFavorite = useIsFavorite(id);

  const { menuOpen, openMenu, closeMenu } = useOpenMenu();
  const toggleFavorite = useToggleFavorite();

  const onFavorite = () => {
    !!goal && toggleFavorite(goal.id, FavoriteType.Goal);
  };

  return (
    <Styled.Interactions ref={interactionsRef}>
      <Styled.FavoriteButtonContainer $isFavorite={isFavorite}>
        <IconButton
          icon={Star18}
          size={Sizes.Large}
          onClick={onFavorite}
          preventDrag
        />
      </Styled.FavoriteButtonContainer>

      <IconButton
        icon={MenuDotsCircle18}
        size={Sizes.Large}
        onClick={openMenu}
        color={Colors.Default}
        preventDrag
      />
      {menuOpen && (
        <GoalContextMenu
          id={id!}
          onClose={closeMenu}
          referenceElement={interactionsRef}
        />
      )}
    </Styled.Interactions>
  );
};
